<template>
  <div class="list-block">
    <div class="list-header">
      <span class="list-title">Markers</span>
      <div class="header-right">
        <span class="count-pill">{{ markers?.length || 0 }}</span>
      </div>
    </div>

    <div v-if="markers && markers.length > 0" class="result-list" :class="`view-${layout}`">
      <div v-for="marker in props.markers" :key="marker.id" class="result-item">
        <MarkerListItem :marker="marker" :organizationId="organizationStore.organizationId"
          :buttonEnabled="buttonEnabled" :layout="layout" @onLocateMarker="locateMarker" />
      </div>
    </div>

    <div v-else class="list-empty">
      <v-icon size="26" color="#4a5a60">mdi-map-marker-off-outline</v-icon>
      <span>No anomaly markers in this area.</span>
    </div>
  </div>
</template>

<script setup>
import { defineOptions, defineProps, defineEmits } from 'vue';
import MarkerListItem from '../list-items/MarkerListItem.vue';
import { useOrganizationStore } from '@/store/organizationStore';

defineOptions({ name: "MarkerList" })

const emits = defineEmits(['OnMarkerSelected'])

const props = defineProps({
  markers: {
    type: Object,
    default: () => null
  },
  buttonEnabled: {
    type: Boolean,
    default: true
  },
  layout: {
    type: String,
    default: 'list'   // 'list' | 'grid'
  }
})

const organizationStore = useOrganizationStore()

function locateMarker(marker) {
  emits('OnMarkerSelected', marker);
}
</script>

<style scoped>
.list-block {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.list-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 0 2px;
}

.list-title {
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #8aa0aa;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 8px;
}

.count-pill {
  min-width: 22px;
  height: 20px;
  padding: 0 7px;
  border-radius: 999px;
  background: rgba(100, 255, 218, 0.1);
  border: 1px solid rgba(100, 255, 218, 0.25);
  color: var(--duallo-accent);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 0.7rem;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
}

.result-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.result-list.view-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));
  gap: 8px;
  align-content: start;
}

.result-item {
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.04);
  border-radius: 10px;
  overflow: hidden;
  transition: background 0.15s ease, border-color 0.15s ease;
}

.result-item:hover {
  background: rgba(100, 255, 218, 0.05);
  border-color: rgba(100, 255, 218, 0.15);
}

.list-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 20px 8px;
  color: #8aa0aa;
  font-size: 0.82rem;
  text-align: center;
  background: rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.04);
  border-radius: 10px;
}
</style>
